import {
    LOCALE_CHANGED,
    SET_ASCENDING,
    SET_MAX_VISIBLE,
    SET_TIMEOUT_BAR_VISIBILITY,
    SET_REPEAT_COUNT_VISIBILITY,
} from './constants'

export function languageChanged(locale) {
    return {
        type: LOCALE_CHANGED,
        payload: locale,
    }
}

export function setAscending(ascending) {
    return {
        type: SET_ASCENDING,
        payload: ascending,
    }
}

export function setMaxVisible(max) {
    return {
        type: SET_MAX_VISIBLE,
        payload: max,
    }
}

export function showTimeoutBar(show) {
    return {
        type: SET_TIMEOUT_BAR_VISIBILITY,
        payload: show,
    }
}

export function showRequestCount(show) {
    return {
        type: SET_REPEAT_COUNT_VISIBILITY,
        payload: show,
    }
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/settings/actions.js